/**
 * Frame-Vorlagen: ein Frame samt seiner Elemente, wiederverwendbar auf anderen
 * Boards.
 *
 * Eine Vorlage ist eine **Kopie**, keine Verknüpfung. Wer sie einsetzt, bekommt
 * eigene Elemente und eigene Mediendateien; spätere Änderungen an der Vorlage
 * wirken nicht zurück. Das ist die Erwartung an eine Vorlage — und es hält
 * Boards voneinander unabhängig, auch über Organisationsgrenzen hinweg.
 */
export const TEMPLATE_SCOPE_LABEL = {
    personal: 'scope.personal',
    organisation: 'scope.organisation',
    platform: 'scope.platform',
};
export const TEMPLATE_SCOPE_HINT = {
    personal: 'scope.personal.hint',
    organisation: 'scope.organisation.hint',
    platform: 'scope.platform.hint',
};
//# sourceMappingURL=template.js.map